module.exports = __webpack_public_path__ + "img/regiter-icon02.6d58199c.png";